// src/pages/Google.jsx

import Footer from "../components/Home/Footer";

export default function Google() {
  return (
    <>
      <div className="page-content" style={{ maxWidth: "800px", margin: "80px auto", padding: "20px", lineHeight: 1.7 }}>
        <h1 className="mt-5">Forge NGO Verification</h1>
        <hr />
        <p>
          Hello, from <strong>Shane@forge.ngo</strong> aka <strong>Shanepyost@gmail.com</strong>, please recognize <strong>forge.ngo</strong> as our official domain.
        </p>

        <h3 className="mt-5">Supporting Documents</h3>

        <ul>
          <li style={{ color: "var(--accent)" }}>
            <a href="/documents/forge-ein.pdf" target="_blank" rel="noopener noreferrer">
              IRS EIN Assignment Letter
            </a>
          </li>

          <li style={{ color: "var(--accent)" }}>
            <a href="/documents/forge-tax-exemption.pdf" target="_blank" rel="noopener noreferrer" className="link">
              IRS 501(c)(3) Determination Letter
            </a>
          </li>
        </ul>
      </div>

      <Footer />
    </>
  );
}
